(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2136],{

/***/ 92136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HomePage_Cards; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/use-smooth-horizontal-scroll/dist/index.js
var dist = __webpack_require__(36319);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./node_modules/react-markdown/src/react-markdown.js
var react_markdown = __webpack_require__(38456);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./components/styleguide/Card/Homepage/MediaCard/media-card.module.scss
var media_card_module = __webpack_require__(16824);
var media_card_module_default = /*#__PURE__*/__webpack_require__.n(media_card_module);
;// CONCATENATED MODULE: ./components/styleguide/Card/Homepage/MediaCard/MediaCard.tsx






var MediaCard = function(param) {
    var tag = param.tag, title = param.title, description = param.description, image = param.image;
    var isMobile = (0,react_responsive.useMediaQuery)({
        maxWidth: 991
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (media_card_module_default()).card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (media_card_module_default()).text,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (media_card_module_default()).tag,
                        children: tag
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (media_card_module_default()).description,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                            children: description
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (media_card_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/homepage/").concat(isMobile ? "mobile-" : "").concat(image),
                    alt: title,
                    layout: "fill"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Card/Homepage/MediaCard/index.ts


;// CONCATENATED MODULE: ./components/views/HomePage/MediaCardCarousel.js





var MediaCardCarousel = function(param) {
    var isVans = param.isVans;
    var ref = (0,dist/* default */.Z)(), scrollContainerRef = ref.scrollContainerRef, handleScroll = ref.handleScroll, scrollTo = ref.scrollTo, isAtStart = ref.isAtStart, isAtEnd = ref.isAtEnd;
    var cardList = [
        {
            id: "price-tracker",
            tag: "Price Tracker",
            title: "We've got you covered.",
            description: "Track the historical price for context on what's genuinely a great lease deal.",
            image: "tracker-graph.png"
        },
        {
            id: "locoscore",
            tag: "LocoScore",
            title: "Search with confidence.",
            description: "Ever wondered if you're getting the best lease deal? Find amazing deals with confidence using our LocoScore.",
            image: "loco-score.png"
        },
        {
            id: "price-alerts",
            tag: "Price Alerts",
            title: "Be the first to know.",
            description: "Never miss out; Save ".concat(isVans ? "van" : "car", "s to your garage and get price alerts when your favourite ").concat(isVans ? "van" : "car", "s drop in price."),
            image: "price-alerts.png"
        },
        {
            id: "configure",
            tag: "Build your ".concat(isVans ? "van" : "car"),
            title: "Configure the ".concat(isVans ? "van" : "car", " you've always wanted."),
            description: "An industry first ".concat(isVans ? "van" : "car", " lease configurator. Configure the ").concat(isVans ? "van" : "car", " you've always wanted. You may even find a higher spec ").concat(isVans ? "van" : "car", " for less."),
            image: "configure.png"
        },
        {
            id: "compare",
            tag: "Compare",
            title: "It's never been easier.",
            description: "We compare so you don't have to. Comparing ".concat(isVans ? "van" : "car", " features has never been easier. Choose the right ").concat(isVans ? "van" : "car", " with confidence."),
            image: "compare.png"
        },
        {
            id: "ethical-code",
            tag: "Ethical code of conduct",
            title: "Integrity at our ❤️",
            description: "We have the highest advertiser criteria in the industry with all our partners bound by our [Ethical Code of Conduct](/ethical-code-of-conduct).",
            image: "trusted.png"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "carousel__container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: function() {
                    return scrollTo(-496);
                },
                disabled: isAtStart,
                className: "slider__button left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/library/arrow-left.svg"),
                    alt: "",
                    height: "20",
                    width: "20"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "deal-slider",
                ref: scrollContainerRef,
                onScroll: handleScroll,
                children: cardList.map(function(card) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCard, {
                        tag: card.tag,
                        title: card.title,
                        description: card.description,
                        image: card.image
                    }, card.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: function() {
                    return scrollTo(496);
                },
                disabled: isAtEnd,
                className: "slider__button right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/library/arrow-right.svg"),
                    alt: "",
                    height: "20",
                    width: "20"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/views/HomePage/Cards.js


var Cards = function(param) {
    var isVans = param.isVans, dealCount = param.dealCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "section-media-cards",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid__container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "media-cards__heading",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "media-cards__title",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: dealCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            (dealCount / 1000000).toFixed(1),
                                            "m"
                                        ]
                                    }) : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Deals available at your finger tips provided from 80+ approved partners"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "media-cards__title",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "\xa330m+"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "We've saved our users over \xa330m in the last year compared to buying on a PCP contract",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                            children: "2"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCardCarousel, {
                isVans: isVans
            })
        ]
    });
};
/* harmony default export */ var HomePage_Cards = (Cards);


/***/ }),

/***/ 16824:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"media-card_card___BIni","text":"media-card_text__A778U","description":"media-card_description__hYach","tag":"media-card_tag__01ZeF","image":"media-card_image__hOSfM","alt-card":"media-card_alt-card__QL_4L","phAnimation":"media-card_phAnimation__AMG3j"};

/***/ })

}]);